for (let index = 1; index <= 5; index++) {
    accordion(index);
}

function accordion (boxNumber) {
    let accordionBox = '.js-box-' + boxNumber;
    let accordionSummary = '.js-summary-' + boxNumber;
    let accordionDescription = '.js-description-' + boxNumber;
    let speed = 300;

    $(accordionSummary).each(function() {
        $(this).on("click", function(event) {
            // デフォルトの挙動を無効化
            event.preventDefault();
            // summaryにis-activeクラスを切り替え
            $(this).toggleClass("is-active");

            if ($(this).parent($(accordionBox)).attr("open")) {
                // アコーディオンを閉じるときの処理
                $(this).nextAll($(accordionDescription)).slideUp(speed, function() {
                    // アニメーションの完了後にopen属性を取り除く
                    $(this).parent($(accordionBox)).removeAttr("open");
                });

                $('.js-btn-' + boxNumber).css('display', 'block')
                $('.js-plus-' + boxNumber).css('display', 'block');
                $('.js-minus-' + boxNumber).css('display', 'none');
            } else {
                // アコーディオンを開くときの処理
                // open属性を付ける
                $(this).parent($(accordionBox)).attr("open", "true");
                // display:none;してからslideDownで開く
                $('.js-minus-' + boxNumber).css('display', 'block');
                $(this).nextAll($(accordionDescription)).hide().slideDown(speed);
                $('.js-plus-' + boxNumber).css('display', 'none');
            }
        });
    });
}
